import { GET_FUNDRAISE_UPDATES_LIST_API_URL } from "../components/Shared/constant";

const GetFundraiseUpdateListAPI = async (accessToken, slug) => {
    const responce = window.axios.get(`${GET_FUNDRAISE_UPDATES_LIST_API_URL}/${slug}/5000/1`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default GetFundraiseUpdateListAPI;